import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const Alert = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #00000099;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;

  > .body {
    max-width: 400px;
    min-height: 110px;
    background: #fff;
    padding: 20px;

    > .title {
      margin-bottom: 10px;
      font-size: 20px;
    }

    > p {
      margin-bottom: 20px;
      font-size: 16px;
    }

    > .button-wrap {
      display: flex;
      justify-content: space-between;

      > button {
        padding: 4px 10px;

        &:last-child {
          background: #fff;
          color: #00000099;
        }
      }
    }
  }
`

function MakeAlert({ cardNumber, newGame, setAlert }) {
  return (
    <Alert
      initial={{ y: -500, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '-100vh', opacity: 0 }}
    >
      <div className="body">
        <p className="title">Confirmation</p>
        <p>Are you sure you want to change card{cardNumber > 1 ? 's' : ''}?</p>
        <div className="button-wrap">
          <button onClick={newGame}>Yes</button>
          <button onClick={() => setAlert()}>Cancel</button>
        </div>
      </div>
    </Alert>
  )
}

export default React.memo(MakeAlert)
